import React from 'react'
import HomePage from '../Components/Home/Home';


const Home = () => {
  return (
    <>
        <HomePage />
    </>
  )
}

export default Home;